/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/js/bundles/sections/hrg-filter.js
/* eslint-disable prettier/prettier */
var herbFilter = function herbFilter() {
  // Precompute whether articles exist for each letter
  var letterHasArticles = {};
  var hrgFilterSection = document.getElementById('hrg-filter-section');
  var herbs = document.querySelectorAll('.herb-item');
  var allLetters = 'abcdefghijklmnopqrstuvwxyz'.split('');

  // Check if herbs and letters exist before proceeding
  if (herbs.length === 0) {
    return;
  }
  var letters = document.querySelectorAll('[data-letter]');
  if (letters.length === 0) {
    return;
  }

  // Initialize the letterHasArticles mapping
  allLetters.forEach(function (letter) {
    letterHasArticles[letter] = Array.from(herbs).some(function (herb) {
      return herb.getAttribute('data-first-letter') === letter;
    });
  });

  // Set default filter to 'A' on page load if 'A' has articles
  filterByLetter('a', false);

  // Add event listeners for each letter
  letters.forEach(function (letter) {
    var letterText = letter.getAttribute('data-letter').toLowerCase();
    if (!letterText) {
      return;
    }
    if (letterText !== 'all' && letterHasArticles[letterText]) {
      letter.addEventListener('click', function () {
        return filterByLetter(letterText);
      });
    }
  });

  // Add event listener for the "Show All" option
  var showAllLetters = document.querySelectorAll('[data-letter="All"]');
  if (showAllLetters.length == 0) {
    return;
  }
  if (showAllLetters.length > 0) {
    showAllLetters.forEach(function (showAllLetter) {
      showAllLetter.addEventListener('click', function () {
        return filterByLetter('all');
      });
    });
  }
  function filterByLetter(selectedLetter) {
    var scrollToSection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var selectedLetterElement = document.querySelector('.selected-letter');
    if (!selectedLetterElement) {
      return;
    }
    selectedLetterElement.innerText = selectedLetter.toUpperCase();
    if (herbs.length === 0) {
      return;
    }
    herbs.forEach(function (herb) {
      var herbFirstLetter = herb.getAttribute('data-first-letter');
      if (!herbFirstLetter) {
        return;
      }

      // Show all herbs if 'Show All' is clicked, otherwise filter by the selected letter
      if (selectedLetter === 'all' || herbFirstLetter === selectedLetter) {
        herb.classList.remove('hidden'); // Show matching herbs
        herb.classList.add('block');
      } else {
        herb.classList.remove('block'); // Remove display block
        herb.classList.add('hidden');
      }
    });
    letters.forEach(function (letter) {
      var letterText = letter.getAttribute('data-letter').toLowerCase();
      var hasArticles = letterHasArticles[letterText];
      if (!letterText) {
        return;
      }
      if (letterText === selectedLetter) {
        letter.classList.remove('text-lime-950', 'underline');
        letter.classList.add('text-beige-950');
      } else if (!hasArticles) {
        letter.classList.remove('text-beige-950', 'underline', 'text-lime-950');
        letter.classList.add('text-gray-500', 'no-underline');
        letter.style.cursor = 'default'; // Disable cursor for letters with no articles
      } else {
        letter.classList.remove('text-beige-950', 'no-underline', 'text-gray-500');
        letter.classList.add('underline', 'text-lime-950');
        letter.style.cursor = 'pointer'; // Enable pointer cursor for clickable letters
      }

      // Handle "Show All" separately
      if (letterText === 'all') {
        letter.style.cursor = 'pointer';
        if (selectedLetter === 'all') {
          letter.classList.remove('text-lime-950', 'underline');
          letter.classList.add('text-beige-950');
        } else {
          letter.classList.remove('text-gray-500', 'no-underline', 'text-beige-950');
          letter.classList.add('text-lime-950', 'underline');
        }
      }
    });
    if (scrollToSection && hrgFilterSection) hrgFilterSection.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/hrg-search.js
var herbSearch = function herbSearch() {
  var searchInput = document.querySelector('.search__box');
  var searchResultsContainer = document.querySelector('.search__results');
  var overlay = document.querySelector('.background-overlay');
  var searchContainer = document.querySelector('.search__container');
  if (!searchInput || !searchResultsContainer || !overlay || !searchContainer) {
    return;
  }
  var searchResultsDisplayed = false;
  searchInput.addEventListener('input', function () {
    var query = this.value.toLowerCase();
    handleSearch(query);
  });
  searchInput.addEventListener('focus', function () {
    var query = this.value.toLowerCase();
    if (query.length > 1 && searchResultsDisplayed) {
      showSearchResults();
    } else if (query.length > 1) {
      handleSearch(query);
    }
  });
  document.addEventListener('click', function (e) {
    if (!searchInput.contains(e.target) && !searchResultsContainer.contains(e.target)) {
      closeSearch();
    }
  });
  function handleSearch(query) {
    searchResultsContainer.innerHTML = '';
    if (query.length <= 1) {
      closeSearch();
      return;
    }
    var normalizedQuery = query.trim().replace(/\s+/g, ' ').toLowerCase();
    if (normalizedQuery.length <= 1) {
      closeSearch();
      return;
    }
    var filteredHerbs = window.herbs.filter(function (herb) {
      return normalizedQuery && herb.title.toLowerCase().includes(normalizedQuery);
    });
    if (filteredHerbs.length > 0) {
      filteredHerbs.forEach(function (herb) {
        var herbElement = document.createElement('a');
        herbElement.href = herb.url;
        herbElement.classList.add('block', 'cursor-pointer');
        herbElement.textContent = herb.title;
        searchResultsContainer.appendChild(herbElement);
      });
      showSearchResults();
      searchResultsDisplayed = true;
    } else {
      closeSearch();
    }
  }
  function showSearchResults() {
    searchResultsContainer.classList.remove('hidden');
    searchResultsContainer.classList.add('flex', 'flex-col', 'gap-2');
    searchInput.classList.remove('rounded-3xl');
    searchInput.classList.add('rounded-t-3xl');
    overlay.classList.remove('hidden');
    searchContainer.classList.add('z-50');
  }
  function closeSearch() {
    searchResultsContainer.classList.add('hidden');
    searchResultsContainer.classList.remove('flex', 'flex-col', 'gap-2');
    searchInput.classList.remove('rounded-t-3xl');
    searchInput.classList.add('rounded-3xl');
    overlay.classList.add('hidden');
    searchContainer.classList.remove('z-50');
    searchResultsDisplayed = false;
  }
};
;// CONCATENATED MODULE: ./src/js/bundles/templates/page.herbguide.js


herbSearch();
herbFilter();
/******/ })()
;